import { PrismicRichText } from "@prismicio/react";
import * as prismicH from "@prismicio/helpers";
import React, {useEffect} from "react";

/**
 * HubSpot Form
 */
export const HubspotForm = ({ slice }) => {
  useEffect(() => {
      const script = document.createElement('script');
      script.src='https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      // set the IDs
      const formPortalID = prismicH.asText(slice.primary.portal_id);
      const formFormID = prismicH.asText(slice.primary.form_id);

      script.addEventListener('load', () => {
          // @TS-ignore
          if (window.hbspt) {
              // @TS-ignore
              window.hbspt.forms.create({
                  portalId: formPortalID,
                  formId: formFormID,
                  region: "na1",
                  target: '#hubspotForm'
              })
          }
      });
  }, []);

  return (
    <section className="contact-form content-section py-5">
      <div className="container">
        <div className="row">
          <div class="col-md-5">
            <PrismicRichText field={slice.primary.copy} />
          </div>
          <div className="col-md-7">
            <div id="hubspotForm"></div>
          </div>
        </div>
      </div>
    </section>
  );

}